import { z } from "zod";
import { idSchema } from "./common.ts";
import type { OrderStatus } from "./orders.ts";

export const createKitchenStationSchema = z.object({ name: z.string().trim().min(1).max(60) });
export const updateKitchenStationSchema = z.object({ name: z.string().trim().min(1).max(60).optional(), sortOrder: z.number().int().min(0).max(1000).optional() });

export const kitchenSettingsSchema = z
  .object({ warnMinutes: z.number().int().min(1).max(240), lateMinutes: z.number().int().min(1).max(480) })
  .refine((s) => s.lateMinutes > s.warnMinutes, { message: "Late must be later than the warning", path: ["lateMinutes"] });

/** Bulk routing: a category's station applies to its items; an item's own station overrides it (null inherits). */
export const stationAssignmentsSchema = z.object({
  categories: z.array(z.object({ id: idSchema, stationId: idSchema.nullable() })).max(500).default([]),
  items: z.array(z.object({ id: idSchema, stationId: idSchema.nullable() })).max(2000).default([]),
});

export const markItemsReadySchema = z.object({ itemIds: z.array(idSchema).min(1).max(100), ready: z.boolean() });

/** Backwards moves the kitchen may make by recalling a bumped ticket (within the recall window). */
export const RECALL_TARGET: Partial<Record<OrderStatus, OrderStatus>> = { ready: "preparing", served: "ready" };
export const RECALL_WINDOW_MINUTES = 60;

export type KitchenStationDto = { id: string; name: string; sortOrder: number };

export type KitchenConfigDto = {
  stations: KitchenStationDto[];
  warnMinutes: number;
  lateMinutes: number;
  menus: Array<{
    id: string;
    name: string;
    categories: Array<{ id: string; name: string; stationId: string | null; items: Array<{ id: string; name: string; stationId: string | null }> }>;
  }>;
};
